import { dayjs } from "./time";

const visibleStatuses = new Set(["sent_for_review", "changes_requested", "approved", "expired", "superseded", "archived"]);

// Presentation only. Retain every published document/version; never trim API data.
export function mealReviewWeeks(documents) {
  const groups = new Map();
  for (const document of documents) {
    const snapshots = (document.versions || []).filter((row) => row.plan_version !== document.plan_version);
    for (const snapshot of [document, ...snapshots]) {
      const row = { ...document, ...snapshot, id: document.id };
      if (!visibleStatuses.has(row.status) || !row.week_start) continue;
      if (!groups.has(row.week_start)) groups.set(row.week_start, []);
      const versions = groups.get(row.week_start);
      if (!versions.some((entry) => entry.id === row.id && entry.plan_version === row.plan_version)) versions.push(row);
    }
  }
  return [...groups.entries()].sort(([a], [b]) => b.localeCompare(a)).map(([week_start, versions]) => {
    versions.sort((a, b) => Number(b.plan_version) - Number(a.plan_version)
      || String(b.updated_at || b.sent_at || "").localeCompare(String(a.updated_at || a.sent_at || "")));
    return { week_start, latest: versions[0], versions };
  });
}

export function formatPlayerDate(value, lang) {
  return value ? dayjs(value).locale(lang).format(lang === "de" ? "DD.MM.YYYY" : "D MMM YYYY") : "";
}

export function formatPlayerWeek(start, end, lang) {
  if (!start || !end) return formatPlayerDate(start || end, lang);
  const first = dayjs(start); const last = dayjs(end);
  if (lang === "de") return `${first.format(first.year() === last.year() ? "DD.MM." : "DD.MM.YYYY")}–${last.format("DD.MM.YYYY")}`;
  return `${first.locale(lang).format(first.year() === last.year() ? "D MMM" : "D MMM YYYY")}–${last.locale(lang).format("D MMM YYYY")}`;
}
